<mat-card-header class="mp-card-header !p-0" [ngClass]="isFmAdmin ? 'admin-warn' : ''">
    <div class="actions">
        <app-toggle-save-legacy
            class="fm-mb-3px"
            *ngIf="status != 4"
            class="icon-size-18"
            [saved]="saved"
            [targetUserId]="uid"
            source="profile"
            (onUserAction)="onUserAction.emit($event)">
        </app-toggle-save-legacy>

        <app-user-actions-menu
            classes="svg-user-action-menu-grey"
            class="three-dot-menu"
            *ngIf="status != 4"
            [showReportProfile]="true"
            [timeZone]="timeZone"
            [targetUserDisplayName]="name"
            [targetUserId]="uid"
            [targetUserProfileUrl]="profileUrl"
            [targetUserPhotoUrl]="photo"
            [status]="status"
            [snoozeStatus]="snoozeStatus"
            [saved]="saved"
            [sharedAvailability]="sharedAvailability"
            [showSeeAvailability]="true"
            [showViewProfile]="false"
            [source]="'profile'"
            [snoozeExpiresAt]="snoozeExpiresAt"
            (onUserAction)="onUserAction.emit($event)">
        </app-user-actions-menu>
    </div>

    <app-profile-image
        class="mp-img-container !rounded-full !mb-0"
        mat-card-avatar
        mat-card-lg-image
        [snoozed]="snoozeStatus"
        [saved]="saved"
        [profileImage]="photo"
        [snoozeTooltip]="snoozeTooltip"
        size="large">
    </app-profile-image>
    <mat-card-title class="mp-name font-t !mb-1">
        <span class="wrap-double-line-el">{{ valid ? name : 'Unknown User' }}</span>
    </mat-card-title>
    <mat-card-subtitle *ngIf="valid" class="up-member-since font-t !mb-2 !text-14-19"
        >{{ numCompletedSessions }} {{ numCompletedSessions == 1 ? ' session' : ' sessions' }}
        {{ sharedSessions > 0 ? ' · ' + sharedSessions + ' together' : '' }}
    </mat-card-subtitle>
    <mat-card-subtitle
        *ngIf="valid && lastMetSessionTime"
        class="up-member-since font-t !mb-2 !text-14-19"
        >{{ lastMet }}
    </mat-card-subtitle>
    <mat-card-subtitle
        *ngIf="email && valid && isFmAdmin"
        class="mp-email-text font-t !mb-2 !text-14-19"
        >{{ email }}
        <mat-basic-chip selectable="false" removeable="false" selected="false" class="mp-email-chip"
            >private
        </mat-basic-chip>
    </mat-card-subtitle>
    <mat-card-subtitle
        *ngIf="email && valid && isFmAdmin"
        class="mp-email-text font-t !mb-2 !text-14-19"
        >{{ userID }}</mat-card-subtitle
    >
    <mat-card-subtitle *ngIf="valid" class="up-member-since font-t !mb-2 !text-14-19"
        >Member since: {{ memberSinceString }}</mat-card-subtitle
    >
    <mat-card-subtitle *ngIf="valid" class="up-member-since font-t !mb-2 !text-14-19">
        <mat-icon class="size-16">place</mat-icon>{{ timeZone }}
    </mat-card-subtitle>

    <div *ngIf="saved">
        <a
            routerLink="availability"
            *ngIf="sharedAvailability; else disableSeeAvailability"
            class="f-btn f-btn--primary f-btn--md focus-with-btn"
            >See availability</a
        >
        <ng-template #disableSeeAvailability>
            <div
                matTooltip="They're currently not sharing their availability."
                matTooltipPosition="below"
                matTooltipShowDelay="200"
                matTooltipClass="f-tooltip">
                <button
                    [disabled]="!sharedAvailability"
                    class="f-btn f-btn--primary f-btn--md focus-with-btn"
                    >See availability</button
                >
            </div>
        </ng-template>
    </div>

    @if (descriptionTagDisplayNames.length > 0 || activityTagDisplayNames.length > 0) {
        <div
            class="w-full h-full my-[15px] flex flex-col items-center justify-center font-avenir text-sm font-bold">
            <div class="flex flex-col gap-[12px] px-[16px]">
                @if (descriptionTagDisplayNames.length > 0) {
                    <div
                        class="flex flex-col items-center justify-center gap-[8px] text-bluegrey-2">
                        My tags
                        <div class="flex flex-col gap-[6px] items-center justify-center">
                            <!-- If 3 or fewer tags, display all in one row -->
                            @if (descriptionTagDisplayNames.length <= 3) {
                                <div class="flex gap-[6px] flex-wrap items-center justify-center">
                                    @for (name of descriptionTagDisplayNames; track name) {
                                        <app-f-toggle [interactable]="false">{{
                                            name
                                        }}</app-f-toggle>
                                    }
                                </div>
                            }

                            <!-- If 4 or more tags, split them into two rows -->
                            @if (descriptionTagDisplayNames.length >= 4) {
                                <div class="flex gap-[6px] flex-wrap items-center justify-center">
                                    @for (
                                        name of descriptionTagDisplayNames.slice(0, 2);
                                        track name
                                    ) {
                                        <app-f-toggle [interactable]="false">{{
                                            name
                                        }}</app-f-toggle>
                                    }
                                </div>
                                <div class="flex gap-[6px] flex-wrap items-center justify-center">
                                    @for (name of descriptionTagDisplayNames.slice(2); track name) {
                                        <app-f-toggle [interactable]="false">{{
                                            name
                                        }}</app-f-toggle>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }

                @if (activityTagDisplayNames.length > 0) {
                    <div
                        class="flex flex-col items-center justify-center gap-[8px] text-bluegrey-2">
                        I focus on
                        <div class="flex flex-col gap-[6px] items-center justify-center">
                            <!-- If 3 or fewer tags, display all in one row -->
                            @if (activityTagDisplayNames.length <= 3) {
                                <div class="flex gap-[6px] flex-wrap items-center justify-center">
                                    @for (name of activityTagDisplayNames; track name) {
                                        <app-f-toggle [interactable]="false">{{
                                            name
                                        }}</app-f-toggle>
                                    }
                                </div>
                            }

                            <!-- If 4 or more tags, split them into two rows -->
                            @if (activityTagDisplayNames.length >= 4) {
                                <div class="flex gap-[6px] flex-wrap items-center justify-center">
                                    @for (name of activityTagDisplayNames.slice(0, 2); track name) {
                                        <app-f-toggle [interactable]="false">{{
                                            name
                                        }}</app-f-toggle>
                                    }
                                </div>
                                <div class="flex gap-[6px] flex-wrap items-center justify-center">
                                    @for (name of activityTagDisplayNames.slice(2); track name) {
                                        <app-f-toggle [interactable]="false">{{
                                            name
                                        }}</app-f-toggle>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</mat-card-header>
